import { ChatMessage } from './types';

const STORAGE_KEY_THREAD_ID = 'chatbot_thread_id';
const STORAGE_KEY_MESSAGES = 'chatbot_messages';

function safeJsonParse<T>(value: string | null): T | null {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}

export function getSessionThreadId(): string | null {
  return sessionStorage.getItem(STORAGE_KEY_THREAD_ID);
}

export function setSessionThreadId(threadId: string) {
  sessionStorage.setItem(STORAGE_KEY_THREAD_ID, threadId);
}

export function getSessionMessages(): ChatMessage[] {
  const raw = sessionStorage.getItem(STORAGE_KEY_MESSAGES);
  const parsed = safeJsonParse<ChatMessage[]>(raw);
  if (!parsed || !Array.isArray(parsed)) return [];
  
  return parsed
    .filter(Boolean)
    .map(m => ({
      id: String(m.id ?? ''),
      role: m.role === 'assistant' ? 'assistant' : 'user',
      content: String(m.content ?? ''),
      createdAt: Number(m.createdAt ?? Date.now())
    }))
    .filter(m => m.id && (m.role === 'user' || m.role === 'assistant')) as ChatMessage[];
}

export function setSessionMessages(messages: ChatMessage[]) {
  sessionStorage.setItem(STORAGE_KEY_MESSAGES, JSON.stringify(messages));
}

